import * as THREE from 'three'
import Experience from './Experience.js'
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';
import { SSAARenderPass } from 'three/addons/postprocessing/SSAARenderPass.js';





export default class Renderer {


    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera
        this.setInstance()
        this.setPostProcessing()
        this.resize()




    }

    setInstance() {
        //une instance du renderer


        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            powerPreference: 'high-performance'
        })


        this.instance.setClearColor('#010101')
        // this.instance.setClearColor('#000000')
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    }

    setPostProcessing() {
        const vertexShader = `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
            }
                `
        const fragmentShader = `
            uniform sampler2D baseTexture;
            uniform sampler2D bloomTexture;
            varying vec2 vUv;
            void main() {
                gl_FragColor = ( texture2D( baseTexture, vUv ) + vec4( 1.0 ) * texture2D( bloomTexture, vUv ) );
            }
        `
        const BLOOM_SCENE = 1;
        this.bloomLayer = new THREE.Layers();
        this.bloomLayer.set(BLOOM_SCENE);
        this.darkMaterial = new THREE.MeshBasicMaterial({ color: 'black' });
        this.materials = {};
        // 
        this.renderPass = new RenderPass(this.scene, this.camera.instance)
        // 
        this.bloomPass = new UnrealBloomPass(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height))
        this.bloomPass.strength = 0.5
        // this.bloomPass.strength = 0.8
        // this.bloomPass.strength = 0.2
        this.bloomPass.radius = 0
        this.bloomPass.threshold = 0
        // this.bloomPass.enabled = false
        // 


        this.bloomComposer = new EffectComposer(this.instance)
        this.bloomComposer.renderToScreen = false
        this.bloomComposer.addPass(this.renderPass)
        this.bloomComposer.addPass(this.bloomPass)


        // 
        this.mixPass = new ShaderPass(
            new THREE.ShaderMaterial({
                uniforms: {
                    baseTexture: { value: null },
                    bloomTexture: { value: this.bloomComposer.renderTarget2.texture }
                },
                vertexShader: vertexShader,
                fragmentShader: fragmentShader,
                defines: {}
            }), "baseTexture"
        )
        this.mixPass.needsSwap = true
        // 
        this.outputPass = new OutputPass()
        // 
        this.ssaaRenderPass = new SSAARenderPass(this.scene, this.camera.instance)
        this.ssaaRenderPass.sampleLevel = 1
        this.ssaaRenderPass.clearColor = '#000000'
        this.ssaaRenderPass.clearAlpha = 1
        // 
        this.finalComposer = new EffectComposer(this.instance)
        this.finalComposer.setPixelRatio(1)
        this.finalComposer.addPass(this.ssaaRenderPass)
        this.finalComposer.addPass(this.mixPass)
        this.finalComposer.addPass(this.outputPass)



        // 



        if (this.experience.debug.active) {

            const bloomFolder = this.experience.debug.ui.addFolder('bloom')
            bloomFolder.add(this.bloomPass, 'enabled').name('enable bloom')
            bloomFolder.add(this.bloomPass, 'strength').min(0).max(2).step(0.001)
            bloomFolder.add(this.bloomPass, 'radius').min(0).max(2).step(0.001)
            bloomFolder.add(this.bloomPass, 'threshold').min(0).max(2).step(0.001)
            bloomFolder.add(this.ssaaRenderPass, 'sampleLevel', {
                'Level 0: 1 Sample': 0,
                'Level 1: 2 Samples': 1,
                'Level 2: 4 Samples': 2,
                'Level 3: 8 Samples': 3,
                'Level 4: 16 Samples': 4,
                'Level 5: 32 Samples': 5
            })
        }


    }
    darkenNonBloomed(obj) {
        if (obj.isMesh && this.bloomLayer.test(obj.layers) === false) {
            this.materials[obj.uuid] = obj.material;
            obj.material = this.darkMaterial;
        }
    }

    restoreMaterial(obj) {
        if (this.materials[obj.uuid]) {
            obj.material = this.materials[obj.uuid];
            delete this.materials[obj.uuid];
        }
    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        this.bloomComposer.setSize(this.sizes.width, this.sizes.height)
        this.finalComposer.setSize(this.sizes.width, this.sizes.height)
    }


    update() {
        // this.instance.render(this.scene, this.camera.instance)
        // this.unrealBloomPass.strength = (Math.sin(this.experience.time.elapsed * 0.001) + 2) * 0.2
        this.scene.traverse(obj => this.darkenNonBloomed(obj))
        this.bloomComposer.render()
        this.scene.traverse(obj => this.restoreMaterial(obj))
        this.finalComposer.render()




    }




}